export default {
  search: {
    total: 10,
  },
};
